import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosResponse } from 'axios';
import { axiosClient } from "../axiosClient";
import { Automation, CreateAutomation, UpdateAutomation } from "../../models/Automation";
import { ClientLeadFrequencyAutomation, FrequencyFormModel } from "../../models/FollowUp";

export const fetchAutomations = createAsyncThunk("automations", async () => {
    const response: AxiosResponse<Automation[]> = await (await axiosClient()).get(`/automations`);
    return response.data
});

export const fetchAutomationById = createAsyncThunk("automations/byId", async (params:{automationId:number}) => {
    const response: AxiosResponse<any[]> = await (await axiosClient()).get(`/automations/${params.automationId}`);
    return response.data
});

export const updateAutomation = createAsyncThunk("automations/update", async (params:{automationId:number,automation: UpdateAutomation}, { rejectWithValue }) => {
    try { 
        await (await axiosClient()).patch(`/automations/${params.automationId}`, {...params.automation});
        return {
            id: params.automationId,
            name: params.automation.name,
            code: params.automation.code
        }
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});

export const createAutomation = createAsyncThunk("automations/create", async (automation: CreateAutomation, { rejectWithValue }) => {
    try {
        const response: AxiosResponse<any> = await (await axiosClient()).post(`/automations`, {...automation});
        return {
            id: response.data.id,
            name: automation.name,
            code: automation.code
        }
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});

//follow up functions
export const fetchFollowUps = createAsyncThunk("followUp/fetchFollowUps", async () => {
    const response: AxiosResponse<FrequencyFormModel[]> = await (await axiosClient()).get(`/followup`);
    return response.data
});

export const createFollowUpMessage = createAsyncThunk("followUp/createFollowUpMessage", async (followUp: FrequencyFormModel, { rejectWithValue }) => {
    try {
        const response: AxiosResponse<FrequencyFormModel> = await (await axiosClient()).post(`/followup`, {...followUp});
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});

export const updateFollowUpMessage = createAsyncThunk("followUp/updateFollowUpMessage", async (params: {followUpId: number, followUp: FrequencyFormModel}, { rejectWithValue }) => {
    try {
        const response: AxiosResponse<FrequencyFormModel> = await (await axiosClient()).patch(`/followup/${params.followUpId}`, {...params.followUp});
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});

export const deleteFollowUpMessage = createAsyncThunk("followUp/deleteFollowUpMessage", async (params: {followUpId: number}, { rejectWithValue }) => {
    try {
        const response: AxiosResponse<any> = await (await axiosClient()).delete(`/followup/${params.followUpId}`);
        return {
            followUpId: params.followUpId
        };
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});

export const assingFollowUpMessage = createAsyncThunk("followUp/assingFollowUpMessage", async (params: {followUpId: number, clientId?: number, leadId?: number}, { rejectWithValue }) => {
    try {
        const response: AxiosResponse<any> = await (await axiosClient()).post(`/followup/${params.followUpId}/asign?clientId=${params.clientId}&leadId=${params.leadId}`);
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});

export const deleteFollowUpMessageExcecution = createAsyncThunk("followUp/deleteFollowUpMessageExcecution", async (params: {followUpXClientLeadId: number, isClient: boolean}, { rejectWithValue }) => {
    try {
        const response: AxiosResponse<any> = await (await axiosClient()).delete(`/followup/${params.followUpXClientLeadId}/deactivate`);
        return {
            automationId: params.followUpXClientLeadId,
            isClient: params.isClient
        };
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});

//clients automations
export const fetchClientAutomations = createAsyncThunk("automation/fetchClientAutomations", async (clientId: number) => {
    const response: AxiosResponse<ClientLeadFrequencyAutomation[]> = await (await axiosClient()).get(`/clients/${clientId}/automations`);
    return response.data
});

export const needToLoadClientAutomation = createAsyncThunk("automation/needToLoadClientAutomation", async (needLoad: boolean) => {
    return needLoad;
});

//lead automations
export const fetchLeadAutomations = createAsyncThunk("automation/fetchLeadAutomations", async (leadId: number) => {
    const response: AxiosResponse<ClientLeadFrequencyAutomation[]> = await (await axiosClient()).get(`/leads/${leadId}/automations`);
    return response.data
});